<template>
  <div class="jewelry-certificate">
    <div class="cert-left">
      <img src="/logo-af.png" alt="Altında Fırsat" class="cert-logo" />
      <div class="cert-field"><span class="cert-label">Ürün:</span> {{ item.productName || '-' }}</div>
      <div class="cert-field"><span class="cert-label">Ölçü:</span> {{ item.size || '-' }}</div>
      <div class="cert-field"><span class="cert-label">Ağırlık:</span> {{ item.weight != null ? item.weight + ' gr' : '-' }}</div>
      <div class="cert-field"><span class="cert-label">Ayar:</span> {{ item.purityLabel || '-' }}</div>
      <div class="cert-field"><span class="cert-label">Seri No:</span> {{ item.serialNumber || '-' }}</div>
      <div class="cert-codes">
        <div class="cert-barcode-wrap">
          <barcode
            v-if="item.serialNumber"
            class="cert-barcode"
            :value="item.serialNumber"
            format="CODE128"
            width="2"
            height="100"
            :displayValue="false"
          />
        </div>
        <div class="cert-qr-wrap">
          <img v-if="qrDataUrl" :src="qrDataUrl" class="cert-qr" alt="QR" />
        </div>
      </div>
    </div>
    <div class="cert-right">
      <div class="cert-photo-box">
        <img v-if="item.photoSrc" :src="item.photoSrc" class="cert-photo" alt="Ürün fotoğrafı" />
        <div v-else class="cert-photo-placeholder">Fotoğraf</div>
      </div>
    </div>
  </div>
</template>

<script>
import VueBarcode from "vue-barcode";
import QRCode from "qrcode";

export default {
  components: { barcode: VueBarcode },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data: () => ({
    qrDataUrl: null,
  }),
  watch: {
    "item.serialNumber": {
      handler() {
        this.generateQR();
      },
      immediate: true,
    },
  },
  methods: {
    async generateQR() {
      if (!this.item || !this.item.serialNumber) {
        this.qrDataUrl = null;
        return;
      }
      try {
        const url = `https://altindafirsat.com/product/${encodeURIComponent(this.item.serialNumber)}`;
        this.qrDataUrl = await QRCode.toDataURL(url, {
          width: 120,
          margin: 1,
        });
      } catch (e) {
        this.qrDataUrl = null;
      }
    },
  },
};
</script>

<style scoped>
.jewelry-certificate {
  display: flex;
  width: 14.8cm;
  height: 10.5cm;
  border: 1px solid #333;
  font-family: Arial, Helvetica, sans-serif;
  background: #fff;
}

.cert-left {
  flex: 0 0 50%;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  border-right: 1px solid #333;
}

.cert-logo {
  width: 100%;
  max-width: 150px;
  height: auto;
  margin-bottom: 8px;
  object-fit: contain;
}

.cert-field {
  font-size: 13px;
  line-height: 1.4;
}

.cert-label {
  font-weight: 700;
  min-width: 70px;
  display: inline-block;
}

.cert-codes {
  display: flex;
  gap: 12px;
  margin-top: auto;
  align-items: flex-end;
}

.cert-barcode {
  display: block;
}
.cert-barcode >>> svg {
  max-width: 100%;
  width: 100%;
  height: auto;
  min-height: 50px;
}

.cert-qr-wrap {
  flex-shrink: 0;
}

.cert-qr {
  width: 80px;
  height: 80px;
  display: block;
}

.cert-right {
  flex: 0 0 50%;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cert-photo-box {
  width: 100%;
  height: 100%;
  min-height: 120px;
  border: 1px dashed #999;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.cert-photo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.cert-photo-placeholder {
  color: #999;
  font-size: 14px;
}

@media print {
  .jewelry-certificate {
    box-shadow: none;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>
